/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the VersionResponse interface.
 */
export function instanceOfVersionResponse(value) {
    if (!('version' in value) || value['version'] === undefined)
        return false;
    return true;
}
export function VersionResponseFromJSON(json) {
    return VersionResponseFromJSONTyped(json, false);
}
export function VersionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'version': json['version'],
    };
}
export function VersionResponseToJSON(json) {
    return VersionResponseToJSONTyped(json, false);
}
export function VersionResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'version': value['version'],
    };
}
